import { render, staticRenderFns } from "./ItemContent.vue?vue&type=template&id=538269ae"
import script from "./ItemContent.vue?vue&type=script&lang=js"
export * from "./ItemContent.vue?vue&type=script&lang=js"
import style0 from "./ItemContent.vue?vue&type=style&index=0&id=538269ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports